export interface MapLevel {
  id: string;
  name: string;
  wordCount: number;
}

export interface MapLocation {
  id: string;
  name: string;
  x: number;
  y: number;
  theme: string;
  unlocked: boolean;
  levels: MapLevel[];
}

export interface MapRoad {
  from: string;
  to: string;
}

export interface MapData {
  locations: MapLocation[];
  roads: MapRoad[];
}

export const MAP_DATA: MapData = {
  locations: [
    {
      id: "siida",
      name: "Siida",
      x: 200,
      y: 300,
      theme: "Familie og hjem",
      unlocked: true,
      levels: [
        { id: "siida-1", name: "Hilsener", wordCount: 8 },
        { id: "siida-2", name: "Familiebetegnelser", wordCount: 12 },
        { id: "siida-3", name: "Hjemmeting", wordCount: 10 },
        { id: "siida-4", name: "Daglige aktiviteter", wordCount: 14 },
      ],
    },
    {
      id: "duottar",
      name: "Duottar",
      x: 420,
      y: 180,
      theme: "Natur og dyr",
      unlocked: false,
      levels: [
        { id: "duottar-1", name: "Villdyr", wordCount: 10 },
        { id: "duottar-2", name: "Planter og bær", wordCount: 12 },
        { id: "duottar-3", name: "Vær og årstider", wordCount: 9 },
        { id: "duottar-4", name: "Fjell og terreng", wordCount: 11 },
        { id: "duottar-5", name: "Reinsdyr", wordCount: 16 },
      ],
    },
    {
      id: "johka",
      name: "Johka",
      x: 600,
      y: 320,
      theme: "Vann og fiske",
      unlocked: false,
      levels: [
        { id: "johka-1", name: "Fiskearter", wordCount: 10 },
        { id: "johka-2", name: "Elvebeskrivelser", wordCount: 8 },
        { id: "johka-3", name: "Fiskeutstyr", wordCount: 12 },
      ],
    },
    {
      id: "market",
      name: "Márkanat",
      x: 380,
      y: 460,
      theme: "Handel",
      unlocked: false,
      levels: [
        { id: "market-1", name: "Tall og telling", wordCount: 15 },
        { id: "market-2", name: "Farger og stoffer", wordCount: 10 },
        { id: "market-3", name: "Mat og drikke", wordCount: 13 },
        { id: "market-4", name: "Duodji – håndverk", wordCount: 11 },
      ],
    },
  ],
  roads: [
    { from: "siida", to: "duottar" },
    { from: "siida", to: "market" },
    { from: "duottar", to: "johka" },
    { from: "market", to: "johka" },
  ],
};

/** Fast lookup: location id → MapLocation */
export const LOCATIONS_BY_ID = Object.fromEntries(
  MAP_DATA.locations.map((loc) => [loc.id, loc])
);
